module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/wallet-e422041bc4728e5e61b529fdf258555d.png";